import axios from 'axios';
import firebase from './store/firebase'

const ROSE_BASE_URL = process.env.VUE_APP_ROSE_API_BASE_URL

export const axiosClient = axios.create({
    baseURL: ROSE_BASE_URL
});

axiosClient.interceptors.request.use(async (config) => {
    const user = firebase.auth.currentUser
    if(!user) return config;
    const token = await user.getIdToken(true)
    config.headers.Authorization = token;

    return config;
})